import { ScopeT } from 'business/definitions';
import { useTranslation } from 'react-i18next';
import {
    isAllExpression,
    isAnyExpression,
    isBlockExpression,
} from 'helpers/scopes';

export const useNoDashboardFilterScopeExpressionDescriptions = (
    scope: ScopeT,
): string | null => {
    const { t } = useTranslation();
    const { expression } = scope;
    if (!expression) {
        return t('chart.noDashboardFiltersModal.needFullAccess');
    }
    if (isAnyExpression(expression)) {
        return t('chart.noDashboardFiltersModal.scopeAnyAccess');
    }
    if (isAllExpression(expression)) {
        return t('chart.noDashboardFiltersModal.scopeAllAccess');
    }
    if (isBlockExpression(expression)) {
        return t('chart.noDashboardFiltersModal.singleBlockAccess');
    }
    return null;
};
